// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__ZQ1LE","rotation":"SmallLoader_rotation__g3YNg"};